import { useAuth } from '@/auth';
import { checkAnyPermissions, PERMISSIONS } from '@/auth/permissions';

/**
 * Hook para verificar permisos relacionados con items de presupuesto
 */
export const useCostosPermissions = () => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  const canView = checkAnyPermissions(userPermissions, [
    PERMISSIONS.VIEW_COSTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canCreate = checkAnyPermissions(userPermissions, [
    PERMISSIONS.CREATE_COSTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canEdit = checkAnyPermissions(userPermissions, [
    PERMISSIONS.EDIT_COSTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canDelete = checkAnyPermissions(userPermissions, [
    PERMISSIONS.DELETE_COSTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageCostos: canCreate || canEdit || canDelete,
    hasAnyPermission: canView || canCreate || canEdit || canDelete,
  };
};
